import { render, staticRenderFns } from "./stripe-form.vue?vue&type=template&id=66ed65d6&scoped=true&"
import script from "./stripe-form.vue?vue&type=script&lang=js&"
export * from "./stripe-form.vue?vue&type=script&lang=js&"
import style0 from "./stripe-form.vue?vue&type=style&index=0&id=66ed65d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed65d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VFadeTransition})
